import { createFileRoute } from "@tanstack/react-router";
import { categoryRouteOptions } from "@/lib/categoryLandingRoute";

export const Route = createFileRoute("/pop-up-campers")(categoryRouteOptions("pop-up-campers"));
